
var lock_scroll = true;
const unlock_scroll_after = 500;
const max_time_before_anim = 10000;
var modal_state = true;
var webgl_textures_loaded = false;

window.scrollTo(0,0);
smoother.paused(true); 
if(jQuery('.page-template-template-accueil').length) {

	// Lock scroll while waiting for animations
	var lock_scroll = true;
	window.scrollTo(0,0);
	smoother.paused(true);

	jQuery(document).ready(function() {

		// Check if Borlabs modal will be there based on PHP output (can be problematic when pages are cached, wrong CSS class is applied)
		if (jQuery('body').hasClass('wait_for_borlabs')) {
			modal_state = true;
		} else {
			modal_state = false;
			unlockAnims();
		}

		// Check if borlabs cookie is accepted with JS, to modify the modal_state if required
		if(typeof window.BorlabsCookie !== 'undefined') {
			consent = window.BorlabsCookie.checkCookieConsent('borlabs-cookie');
			console.log('Consent : '+consent);
			if(consent == true) {
				jQuery('body').removeClass('wait_for_borlabs');
				modal_state = false;
				unlockAnims();
			} else {
				modal_state = true;
			}
		} else {
			modal_state = false;
			unlockAnims();
		}

		// Lock anims and Blob anim
		var animated_elements = jQuery('section#entete *, .zone_dessin .svg_container, .overlay_contact_fixed, header.navbar > *').not('.ronds_exterieurs, .loading_container, #blob');
		animated_elements.css("animation-play-state", "paused");
		jQuery('#blob').css("animation-play-state", "paused");

		// Unlock all anims but Blob
		function unlockAnims() {
			jQuery(function($) {
				animated_elements.css("animation-play-state", "running");
				document.dispatchEvent(windowresizeEvent);
				setTimeout(() => {
					smoother.paused(false);
					lock_scroll = false;
				}, unlock_scroll_after);
			}); 
		}

		// Check every 500 ms if Blob textures are loaded and modal is accepted
		check_if_anim_blob = setInterval(() => {
			if(modal_state == false && webgl_textures_loaded == true) {
				jQuery('#blob').css("animation-play-state", "running");
				clearInterval(check_if_anim_blob);
				clearTimeout(time_before_anim);

				document.dispatchEvent(windowresizeEvent);

				setTimeout(() => {
					smoother.paused(false);
					lock_scroll = false;
				}, unlock_scroll_after);
			}
		}, 500);

		// Consider textures are loaded after 10 seconds ("max_time_before_anim)
		time_before_anim = setTimeout(() => {
			webgl_textures_loaded = true;
		}, max_time_before_anim);

		jQuery('._brlbs-button-area a').click(function () { 
			modal_state = false;
			unlockAnims();
		});
		
	});

} else {
	lock_scroll = false;
	smoother.paused(false);
}